<template>
   <div class="modal-container has-text-centered">
         <div class=" bottom20">
           <div class="has-background-dark"> <div class="is-size-4"><span class=" has-text-white">Import Bundle</span></div></div>
        </div>

        <div class="top10">
            Select the bundles you want to include:
        </div>

        <div class="shareTree">
             <div class="has-text-left">
                <share-tree :listName="topBundle.listName" :children="topBundle.children" :depth="0" :id="topBundle.id"></share-tree>
             </div>
        </div>

        <button v-show="!link" class="button is-small top20 is-coolGreen" @click="send"  id="getButt">IMPORT</button><br>
      
        <button class="button is-small top20" @click="cancel">CANCEL</button>
        <br><br>
   </div>
</template>


<script>

import ShareTree from '../components/ShareTree'
import { AZEventBus } from '../components/AZEventBus'

export default{
    props: {
        bundle: Array,
        shareId: Number,
        importAcl: Number,
        notId: Number
    },

    components: {
        ShareTree
    },

    data: function(){
        return {
            topBundle: {listName: '', children: [], id: 0},
            bundleTree: [],
            link: false
        }
    },

    mounted: function(){

        var self = this

        
        this.topBundle = this.bundle[0]

        //create a tree of ids for all bundles under topBundle
        function buildIt(b){
            var obj = {};
            obj.id = b.id;
            obj.children = [];
            obj.selected = true;
            obj.listName = b.listName
            obj.items = b.items

            function buildChildren(kids){
                var arr = []
                kids.forEach((e) => {
                    var temp = {
                        id: e.id,
                        children: [],
                        selected: true,
                        listName: e.listName,
                        items: e.items
                    }
                    if(e.children){
                        temp.children = buildChildren(e.children)
                    }
                    arr.push(temp)
                })
                return arr
            }
            
            if(b.children){
               obj.children = buildChildren(b.children)
            }

            self.bundleTree.push(obj)
        }

        buildIt(this.topBundle)


        function processClick(id, arr, selected){
            arr.forEach(e => {
                if(e.id == id){
                    e.selected = selected
                    return
                }
                if(e.children){
                    processClick(id, e.children, selected)
                }
            })
        }

        AZEventBus.$on('onShareTreeClicked', msg => {
            if(self.bundleTree[0].id == msg.id){
                event.preventDefault()
                return
            }
            processClick(msg.id, self.bundleTree, msg.selected)
        }) 
 
    },

    beforeDestroy: function(){
        //too tricky to remove for now/ AZEventBus.$off('onShareTreeClicked')
    },

    methods: {
        cancel: function(){
            this.$emit('close')
        },

        send: function(){
            //find checked bundles and build object that contains them
            var self = this;

            var bundles = []
            var cards = []

            function buildBlob(arr){

                //find all bundles and all cards


                var tempArr = [];
                arr.forEach(e => {
                    var origBundle = e

                    var temp = {
                        listName: e.listName,
                        origId: e.id,
                        children: e.children,
                        
                    }
                    
                    if(e.selected){
                        temp.items = e.items;
                    } else {
                        temp.items = [];
                    }

                    bundles.push(temp)

                    if(e.selected){
                        origBundle.items.forEach(n => {
                            
                            n.origId = n.id
                            delete n.id


                            let ind = cards.findIndex(i => {
                                return i.origId == n.origId
                            })

                            if(ind == -1){
                                cards.push(n)
                            }
                        })
                    }

                    if(e.children){
                        temp.children = buildBlob(e.children);
                    }
                    tempArr.push(temp);
                })
                 
                return tempArr;
            }
           

            buildBlob(this.bundleTree);

            function w(data){
                az.addRemSpinner(false, 'id', 'getButt');
                if(data.response == 'error'){
                    self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support'})
                } else {
                    //self.navToBundles();
                    self.$emit('close')
                    self.$router.push('/bundles')
                }
            }

            function n(){
                az.addRemSpinner(false, 'id', 'getButt');
                self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support'})
            }
            
            az.addRemSpinner(true, 'id', 'getButt');
            this.$root.app.apiClient.post('subs/data/importbundle', {cards: cards, bundles: bundles, shareId: this.shareId, importAcl: this.importAcl, notId: this.notId}, w, n);
        },

        navToBundles: function(){
            window.open('/bundles', '_self', false)
        }

       
    }

}
</script>


<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }
</style>